import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../components/layout/AppShell';
import { CheckCircle, BookOpen, Zap, Users, Trophy, Briefcase, Folder, Radio, ArrowLeft } from 'lucide-react';

const SubscriptionPage = () => {
  const navigate = useNavigate();

  return (
    <AppShell>
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <button 
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors mb-4 font-medium"
          >
            <ArrowLeft size={18} />
            <span>Back</span>
          </button>
          <h1 className="text-2xl font-bold text-gray-900">Subscription & Plan</h1>
          <p className="text-sm text-gray-500 mt-1">Manage your Vet Collab membership</p>
        </div>

        {/* Free Access Banner */}
        <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex items-center justify-between mb-8 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="bg-green-100 p-2 rounded-full text-green-600">
              <CheckCircle size={20} className="fill-current text-white" />
            </div>
            <div>
              <p className="font-semibold text-green-900">All features free until December 31</p>
              <p className="text-sm text-green-700">Full access included for all students.</p>
            </div>
          </div>
          <div className="px-3 py-1 bg-white border border-green-200 text-green-700 text-xs font-medium rounded-full shadow-sm">
            Free till Dec 31
          </div>
        </div>

        {/* Plan Card */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-12">
          <div className="bg-[#6b46c1] p-6 text-white">
            <div className="text-xs font-semibold tracking-wider uppercase mb-2 opacity-90">VET COLLAB</div>
            <h2 className="text-3xl font-bold mb-1">Student Plan</h2>
            <p className="text-[#d8b4fe]">For veterinary students in India</p>
          </div>
          
          <div className="p-8">
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3">
                <BookOpen size={18} className="text-[#6b46c1] mt-0.5" />
                <span className="text-gray-700 text-sm">Learn from real veterinary cases across India</span>
              </li>
              <li className="flex items-start gap-3">
                <Zap size={18} className="text-[#6b46c1] mt-0.5" />
                <span className="text-gray-700 text-sm">AI explains every case</span>
              </li>
              <li className="flex items-start gap-3">
                <Users size={18} className="text-[#6b46c1] mt-0.5" />
                <span className="text-gray-700 text-sm">Discuss with verified veterinarians</span>
              </li>
              <li className="flex items-start gap-3">
                <Trophy size={18} className="text-[#6b46c1] mt-0.5" />
                <span className="text-gray-700 text-sm">Participate in monthly case challenges</span>
              </li>
              <li className="flex items-start gap-3">
                <Briefcase size={18} className="text-[#6b46c1] mt-0.5" />
                <span className="text-gray-700 text-sm">Internship & job alerts</span>
              </li>
              <li className="flex items-start gap-3">
                <Folder size={18} className="text-[#6b46c1] mt-0.5" />
                <span className="text-gray-700 text-sm">Build your veterinary portfolio</span>
              </li>
              <li className="flex items-start gap-3">
                <Radio size={18} className="text-[#6b46c1] mt-0.5" />
                <span className="text-gray-700 text-sm">Priority access to webinars in and outside India</span>
              </li>
            </ul>

            <div className="pt-6 border-t border-gray-100">
              <p className="text-xs text-gray-500 leading-relaxed">
                Your student membership is complimentary until December 31. We'll notify you well in advance about membership options before your free access ends.
              </p>
            </div>
          </div>
        </div>

        {/* FAQs */}
        <div className="mb-8">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Frequently asked</h3>
          
          <div className="space-y-3">
            <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
              <h4 className="font-semibold text-gray-900 text-sm mb-1">When will I be charged?</h4>
              <p className="text-sm text-gray-600">
                From December 31, we'll collect payment details to keep your student profile active. Until then, full access is free for all students.
              </p>
            </div>

            <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
              <h4 className="font-semibold text-gray-900 text-sm mb-1">What happens on December 31?</h4>
              <p className="text-sm text-gray-600">
                We'll reach out to collect payment details to keep your student profile active. Until then, everything is free.
              </p>
            </div>

            <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
              <h4 className="font-semibold text-gray-900 text-sm mb-1">Is this plan only for students?</h4>
              <p className="text-sm text-gray-600">
                Yes. The Student Plan is exclusively for enrolled veterinary students at ₹499/month — a fraction of the professional rate.
              </p>
            </div>
          </div>
        </div>

      </div>
    </AppShell>
  );
};

export default SubscriptionPage;
